import FillBlankSetting from "./KrFillBlankSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrFillBlankSetting = install(FillBlankSetting); // 生成带有 install 方法的组件

export default KrFillBlankSetting;
